export default {
    init() {
        this.initSMS();
    },
    finalize() {
    },
    initSMS() {
        let $this = this;

        $('#sendSmsCodeButton').on('click', function (e) {
            $this.changeDisabledOfAllButtons(true);        

            $.ajax({
                type: 'POST',
                url: '/phone-code-sms',
                success: function () {
                    $('#subtitle2')
                        .addClass('text-danger')
                        .html("An SMS with a confirmation code was sent to " + ($('#phone').val()));
    
                    $('#sendSmsCodeButton').addClass('d-none');
                    $('#confirmCodeBlock').removeClass('d-none');

                    $this.changeDisabledOfAllButtons(false);                   
                },
            });            
        });        

        $('body').on('click', '#phone-confirm-sms', function (e) {
            $this.changeDisabledOfAllButtons(true);        

            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/phone-code-sms',
                success: function (response) {
                    $('#subtitle2')
                        .addClass('text-danger')
                        .html("Another code was sent to " + ($('#phone').val()));

                    $this.changeDisabledOfAllButtons(false);                               
                },
            });
        });
        $('body').on('click', '#phone-confirm-voice', function (e) {
            $this.changeDisabledOfAllButtons(true);        

            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/phone-code-voice',
                success: function (response) {
                    $('#subtitle2')
                        .addClass('text-danger')
                        .html("You should receive a phone call with the verification code right away.");

                    $this.changeDisabledOfAllButtons(false);                         
                },
            });
        });
        $('body').on('click', '.change-phone-button', function(e) {
            $('#title').html('New Phone number');
            $('#subtitle1').html('Please enter a new phone number');
            $('#subtitle2').addClass('d-none');
                
            $('#sendSmsCodeButton').addClass('d-none');
            $('#confirmCodeBlock').addClass('d-none');
            $('#secondaryActionsBlock').addClass('d-none');
            $('#changePhoneAfterAttemptsButton').addClass('d-none');
            $('#changePhoneBlock').removeClass('d-none');
        });

        $('#changePhoneButton').on('click', function(e) {
            $('#changePhoneButton').attr('disabled', true);

            $.ajax({
                type: 'POST',
                url: '/change-phone',
                data: ({
                    phone: $('#changePhone').val(),
                }),
                success: function (response) {
                    $('#title').html('Phone verification');
                    $('#subtitle1').html('To keep your account safe, we need to verify your phone number. ');
                    $('#subtitle2')
                        .removeClass('text-danger')
                        .html('To receive a code ' + $('#changePhone').val() + ' click button below.');
        
                    $('#sendSmsCodeButton').removeClass('d-none');
                    $('#secondaryActionsBlock').removeClass('d-none');
                    $('#changePhoneBlock').addClass('d-none');    
                    $('#changePhoneBlock').addClass('d-none');    
                    $('#stepWithNewPhone').removeClass('d-none');

                    $('#changePhoneButton').attr('disabled', false);        
        
                    $('#phone').val($('#changePhone').val());    
                },
                error: function(response) {
                    $('#subtitle2')
                        .removeClass('d-none')
                        .addClass('text-danger')
                        .html('You entered a phone number that is already assigned to existing account.');

                    $('#changePhoneButton').attr('disabled', false);
                }
            });           
        });

        $('#checkCodeButton').on('click', function(e) {
            if ($('#code').val() == "") {
                $('#code').addClass('border-danger');
                return;
            }

            $this.changeDisabledOfAllButtons(true);

            $.ajax({
                url: '/phone-confirm',
                type: 'POST',
                data: ({
                    code: $('#code').val()
                }),
                success: function (response) {
                    $this.changeDisabledOfAllButtons(false);

                    $('#title').html('Phone Verified');
                    $('#subtitle1').html('Congratulations. You may continue to your account.');            
                    $('#subtitle2').addClass('d-none');
                    $('#confirmCodeBlock').addClass('d-none');
                    $('#secondaryActionsBlock').addClass('d-none');
                    $('#continueButton').removeClass('d-none');
                },
                error: function (response) {
                    if (response.responseJSON.attempt >= 6) {
                        $('#subtitle2').html('You have tried too many times. You can change your phone number to try again.');
                        $('#confirmCodeBlock').addClass('d-none');
                        $('#secondaryActionsBlock').addClass('d-none');
                        $('#changePhoneAfterAttemptsButton').removeClass('d-none');
                        $('code').val('');
                    } else {    
                        $('#code').val("");

                        let remainingAttempts = 6 - response.responseJSON.attempt;

                        $('#subtitle2').html("You entered an incorrect code. You have " 
                            + remainingAttempts + " more attempts.");
                    }

                    $this.changeDisabledOfAllButtons(false);

                },
            });              
        });

        $('#removePhoneButton').on('click', function(e) {
            $this.changeDisabledOfAllButtons(true);

            $.ajax({
                url: '/phone-confirmation-delete',
                type: 'POST',
                success: function (response) {
                    $this.changeDisabledOfAllButtons(false);

                    $('#title').html('Phone Verified');
                    $('#subtitle1').html('Congratulations. You may continue to your account.');            
                    $('#subtitle2').addClass('d-none');
                    $('#confirmCodeBlock').addClass('d-none');
                    $('#secondaryActionsBlock').addClass('d-none');
                    $('#continueButton').removeClass('d-none');
                    $('#changePhoneBlock').addClass('d-none');
                },
            }); 
        });

        $('#code').on('input', function(e) {
           if ($(this).val() !== "") $(this).removeClass('border-danger'); 
        });
    },

    changeDisabledOfAllButtons(disabled) {
        $('#sendSmsCodeButton').attr('disabled', disabled);
        $('#checkCodeButton').attr('disabled', disabled);
        $('#phone-confirm-voice').attr('disabled', disabled);
        $('#change-phone-number').attr('disabled', disabled);  
        $('#changePhoneButton').attr('disabled', disabled);
        $('#removePhoneButton').attr('disabled', disabled);      
    }

};
